import { render, staticRenderFns } from "./PaymentMethodCreate.vue?vue&type=template&id=0ad75f56&"
import script from "./PaymentMethodCreate.vue?vue&type=script&lang=ts&"
export * from "./PaymentMethodCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports